<div class="auth-wrapper">
  <!-- Painel de marca (esconde no mobile) -->
  <div class="auth-brand-col d-none d-lg-block">
    <app-banner class="w-100 h-100"></app-banner>
  </div>

  <!-- Coluna de acesso -->
  <div class="auth-form-col">
    <div class="auth-card animate__animated animate__fadeIn animate__faster">
      <!-- Header de marca (só mobile, onde o painel some) -->
      <div class="auth-mobile-brand d-lg-none">
        <app-logo></app-logo>
        <p class="auth-mobile-tagline">Todos os seus canais de venda em um só lugar.</p>
      </div>

      @if (authenticated) {
      <h2 class="auth-title">Olá, {{ userName }}</h2>
      <p class="auth-sub">Sua sessão está ativa.</p>
      <button type="button" class="auth-btn" (click)="login()">
        Continuar <i class="bx bx-right-arrow-alt"></i>
      </button>
      } @else {
      <h2 class="auth-title">Entre na sua conta</h2>
      <p class="auth-sub">Use seu usuário Sisand para acessar.</p>
      <button type="button" class="auth-btn" (click)="login()">
        Entrar <i class="bx bx-right-arrow-alt"></i>
      </button>
      }

      <div class="auth-secure">
        <i class="bx bx-lock-alt"></i> Login único Sisand
      </div>
      <div class="auth-foot">
        Ainda não é cliente?
        <a href="https://sisand.com.br" target="_blank" rel="noopener">Fale com a Sisand</a>
      </div>
    </div>
  </div>
</div>
